<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="设备uuid：" prop="code">
                    <el-input v-model.trim="form.device_id" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="uid：" prop="uid">
                    <el-input v-model.trim="form.uid" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="属性/事件：" prop="identifier">
                    <el-select v-model.trim="form.identifier" placeholder="请选择" filterable clearable>
                        <el-option v-for="item in identifierList" :key="item.key" :label="item.value"
                            :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间：" prop="createTime">
                    <el-date-picker v-model="createTime" type="datetimerange" start-placeholder="开始时间"
                        end-placeholder="结束时间" format="YYYY-MM-DD HH:mm:ss" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="list" size="mini">
            <el-table-column label="设备uuid" width="150">
                <template v-slot="scope">
                    <span>{{ scope.row.device_id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="uid" width="150">
                <template v-slot="scope">
                    <span>{{ scope.row.uid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="产品型号" width="150">
                <template v-slot="scope">
                    <span>{{ scope.row.product_key }}</span>
                </template>
            </el-table-column>
            <el-table-column label="mqtt上报类型">
                <template v-slot="scope">
                    <span>{{ scope.row.action_type }}</span>
                </template>
            </el-table-column>
            <el-table-column label="属性/事件类型">
                <template v-slot="scope">
                    <span>{{ scope.row.identifier }}</span>
                </template>
            </el-table-column>
            <el-table-column label="消息id" width="200">
                <template v-slot="scope">
                    <span>{{ scope.row.message_id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="消息来源" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.source_type }}</span>
                </template>
            </el-table-column>
            <el-table-column label="设备上报时间" width="180">
                <template v-slot="scope">
                    <span>{{ scope.row.timestamp }}</span>
                </template>
            </el-table-column>
            <el-table-column label="描述" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.description }}</span>
                </template>
            </el-table-column>
            <el-table-column label="值">
                <template v-slot="scope">
                    <el-button type="primary" size="mini" @click="lookJson(scope.row.value)">查看</el-button>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="180">
                <template v-slot="scope">
                    <span>{{ scope.row.created_at }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
        <el-dialog title="" v-model="jsonVisible" width="1400px" center>
            <json-editor-vue class="editor" v-model="jsonValue" />
        </el-dialog>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import util from '../../../util/util'
import api from '../../../axios/api'
import JsonEditorVue from 'json-editor-vue3'
import dayjs from 'dayjs'

export default {
    components: {
        JsonEditorVue,
    },
    setup() {
        const router = useRouter()
        const form = reactive({
            device_id: '',
            uid: '',
            identifier: '',
            start_time: '',
            end_time: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])
        const identifierList = ref([])
        const jsonVisible = ref(false)
        const jsonValue = ref('')
        const createTime = ref('')

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const getOnlineIdentifierList = async () => {
            const res = await api.OnlineIdentifierList()
            console.log('getOnlineIdentifierList', res)
            if (res.data.code === 200) {
                identifierList.value = res.data.data.list || []
            }
        }

        const onSearch = async () => {
            if (!form.device_id) {
                ElMessage.error('请输入设备uuid')
                return
            }

            console.log('toRaw(form)', toRaw(form))
            const res = await api.OnlineLogList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { list: result, page_info } = res.data.data
                list.value = result
                pagination.total = page_info.total
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const add = () => {
            router.push('/salespartner/list/add/0')
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        const lookJson = (json) => {
            jsonValue.value = json ? JSON.parse(json) : ''
            jsonVisible.value = true
        }

        watch(createTime, (newVal) => {
            if (newVal) {
                form.start_time = dayjs(newVal[0]).format('YYYY-MM-DD HH:mm:ss')
                form.end_time = dayjs(newVal[1]).format('YYYY-MM-DD HH:mm:ss')
            } else {
                form.start_time = ''
                form.end_time = ''
            }
        })

        onMounted(() => {
            getOnlineIdentifierList()
        })


        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            add,
            resetForm,
            util,
            jsonVisible,
            jsonValue,
            lookJson,
            createTime,
            identifierList
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
    ::v-deep(tbody) {
        tr {
            font-family: 'Manrope';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            opacity: 0.8;
        }
    }
    .editor {
        height: 400px;
    }
}
</style>
